export const Role = {
  ChiRhosOwner: 'ChiRhosOwner',
  TenantOwner: 'TenantOwner',
  TenantAdmin: 'TenantAdmin',
}
